import { render } from "./OrderConfirmation.vue?vue&type=template&id=012d3a57&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=012d3a57&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012d3a57"]])

export default __exports__